module.exports = __webpack_public_path__ + "static/media/IMG_4283.0a6a1fff.PNG";